import { useNavigate } from "react-router-dom";
import noResults from '../assets/images/noresults.png'

function NoResults({ title, description, image, fromHome = "false" }) {
    const navigate = useNavigate();

    return (
        <div className={`NoResults ${fromHome === "true" && `noPageFound`}`}>
            <div className="noResultsBody">
                <img src={image || noResults} alt="No results" />
                <p className="noResTitle">{title}</p>
                <p className='noResDesc'>{description}</p>
                {fromHome === "true" &&
                    <button
                        className={`back-home-btn save-button primary-button button `}
                        type="submit"
                        onClick={() => navigate("/")}
                    > Back to home
                    </button>
                }
            </div>
        </div>
    );
}

export default NoResults;
